import type { FC, ReactNode } from "react";
import type { IComponentBaseProps } from "@/shared/config";
import gradientTop from "/assets/images/G.png";
import gradientTopMobile from "/assets/images/gradientTopMobile.svg";
import gradientBottomMobile from "/assets/images/gradientBottomMobile.svg";
import gradientBottom from "/assets/images/gradientFooter.svg";
import { useCN } from "@/shared/lib/hooks";
import type { ISection } from "../config";

/**
 * Компонент секции
 * @constructor
 * @returns {ReactNode}
 */
const Section: FC<ISection & IComponentBaseProps> = ({
  baseClass = "section",
  id,
  children = null,
  slotHeader = null,
  extraClasses = {},
  extraAttrs = {},
  utilClasses = [],
  slotFooter = null,
  withGradientTop,
  withGradientBottom,
}): ReactNode => {

  const { getCN } = useCN(baseClass);
  const hasGradientTop = withGradientTop?.enabled;
  const hasGradientBottom = withGradientBottom?.enabled;

  return (
    <section id={id} className={getCN("", extraClasses, [ ...utilClasses, "relative" ])} {...extraAttrs}>
      {hasGradientTop && (
        <picture>
          <source srcSet={gradientTopMobile} media={"(max-width: 1319px)"} />
          <img
            src={gradientTop}
            alt={"gradient top"}
            className={"absolute inset-0 w-full pointer-events-none max-w-300 select-none top-0 mobile:contain tablet:!object-[center_-50vh]"} />
        </picture>
      )}

      {hasGradientBottom && (
        <picture>
          <source srcSet={gradientBottomMobile} media={"(max-width: 520px)"} />
          <img
            src={gradientBottom}
            alt={"gradient bottom"}
            className={"absolute bottom-0 w-full pointer-events-none select-none"}
          />
        </picture>
      )}

      <div className={`${getCN("wrap")} container relative z-10`}>
        {!!slotHeader && <header className={getCN("header")}>{slotHeader}</header>}
        {!!children && (
          <div
            className={getCN("content", {}, [
              "flex flex-col gap-50 mobile:gap-12",
            ])}
          >
            {children}
          </div>
        )}
        {!!slotFooter && <footer className={getCN("footer")}>{slotFooter}</footer>}
      </div>
    </section>
  );
};

export {
  Section,
};